import { Tab, TabsComponent } from '@components';
import { CollapsibleCard } from '@atgfr8/atg-ui-tailwind';
import { VendorContractViewModel } from '@typeDefinitions/vendorTypes';
import { createSignal } from 'solid-js';

import { calculateSettlementCount } from '../stops/stopsEditor/utilFunctions';
import { Settlement } from './Settlement';
import { VendorPay } from './VendorPay';

type Props = {
  vendor: VendorContractViewModel;
  index: number;
};

export const VendorCosts = (props: Props) => {
  const [activeTab, setActiveTab] = createSignal<number>(0);

  const tabs = [
    'Vendor Pay',
    `SETTLEMENTS(${calculateSettlementCount(
      `vendors.${props.index}.lineItems`,
    )}) `,
  ];

  const onClick = (index: number) => {
    setActiveTab(index);
  };

  return (
    <CollapsibleCard startTitle="Vendor Costs" class="mb-2">
      <TabsComponent
        tabs={tabs.map((item) => (
          <Tab onClick={onClick}>{item}</Tab>
        ))}
        activeTab={activeTab()}
        onTabClick={setActiveTab}
      />
      <div class="tab1">
        <div class={activeTab() === 0 ? 'block' : 'hidden'}>
          <VendorPay vendor={props.vendor} index={props.index} />
        </div>
        <div class={activeTab() === 1 ? 'block' : 'hidden'}>
          <Settlement index={props.index} />
        </div>
      </div>
    </CollapsibleCard>
  );
};
